defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PromotionSpots',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Common/Framework/ScriptLibraries/Scripts/TinySlider'
  ],
  function (m, TinySlider) {

    // Template:
    const PromotionSpots = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.title = controller.dictionary('PromotionTitle');
        this.items = this.promotionSpots || [];

        this.initSlider = (ignore$element, isNew) => {
          if (!isNew) {
            const _sliderOptions = {
              container: '.play-together-promotion__slider',
              center: true,
              loop: false,
              items: 1,
              slideBy: 1,
              mouseDrag: true,
              autoplay: false,
              autoplayButtonOutput: false,
              autoWidth: false,
              nav: true,
              navPosition: 'bottom',
              controlsContainer: '.play-together-promotion__slider-navigation',
              responsive: {
                768: {
                  items: 3,
                  center: this.items < 3
                }
              }
            };

            this.slider = TinySlider(_sliderOptions);
          }
        };
      },
      view: function (controller, ignoreArgs, slots) {
        const itemStructure = (item) => {
          return m('.play-together-promotion__item', [
            m('.play-together-promotion__item-image-container',
              m('img.play-together-promotion__item-image', {
                src: item.image.source
              })
            ),
            m('.play-together-promotion__item-title', item.title),
            m('.play-together-promotion__item-description', m.trust(item.text)),
          ]);
        };

        return m('.play-together-promotion-spot', [
          m('.play-together-promotion__title', controller.title),
          m('.play-together-promotion__slider-wrapper', [
            m('.play-together-promotion__slider', {
              config: controller.initSlider
            }, controller.items.map((item) => {
              return itemStructure(item);
            })),
            m('.play-together-promotion__slider-navigation', [
              m('.play-together-promotion__slider-navigation-arrow.play-together-promotion__slider-navigation-arrow--left',
                m('svg.play-together-promotion__slider-navigation-arrow-icon',
                  m('use', {
                    href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow'
                  })
                )
              ),
              m('.play-together-promotion__slider-navigation-arrow.play-together-promotion__slider-navigation-arrow--right',
                m('svg.play-together-promotion__slider-navigation-arrow-icon',
                  m('use', {
                    href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow'
                  })
                )
              )
            ])
          ]),
          slots?.$footer ?  m('.play-together-promotion__footer', slots?.$footer) : null
        ]);
      }
    };

    // Public functions:
    return PromotionSpots;

  });
